import { CreateRoleItem, RoleItem, RoleSummary, UpdateRoleItem } from 'src/stores/roles-store';
import DataStoreMock from './base/data-store';
import FormStoreMock from './base/form-store';
import { Query } from 'src/core/stores/data-store';
import { RoleSummaryMockData } from '../data-sources/role-summary';

export class RoleSummaryStoreMock extends DataStoreMock<RoleSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      errorMessage: undefined,
      count: RoleSummaryMockData.length,
      items: RoleSummaryMockData,
    });
    return true;
  }
}

export class RoleItemStoreMock extends FormStoreMock<RoleItem, CreateRoleItem> {
  rolePermissionsBasePath = 'permissions';

  public async update(id: string, item: UpdateRoleItem) {
    return { isSuccess: true };
  }

  public async loadRole() {
    return RoleSummaryMockData[0];
  }

  public async addRolePermissions(id: string, permissionIds: string[]) {
    return true;
  }

  public async deleteRolePermissions(id: string, permissionIds: string[]) {
    return true;
  }
}
